<template>
  <div :key="updateDisplay" class="layoutPadding">
    <el-dialog
      center
      title="Welcome to fiifi"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="false"
      :visible.sync="showNewModal"
    >
      <div style="width: 100%; text-align: center; word-break: normal">
        <p>
          fiifi is a system of record and deal flow manager that helps aggregate
          investment information from multiple sources, giving you a transparent
          view of your portfolio
        </p>
      </div>
      <div class="welcome-callout row">
        <div class="col-sm">
          <i class="fa fa-eye fa-5x" aria-hidden="true"></i>
          <p>Visualize your portfolio.</p>
        </div>
        <div class="col-sm">
          <i class="fa fa-line-chart fa-5x" aria-hidden="true"></i>
          <p>Monitor your investments.</p>
        </div>
        <div class="col-sm">
          <i class="fa fa-star fa-5x" aria-hidden="true"></i>
          <p>Make informed decisions.</p>
        </div>
      </div>
      <div style="width: 100%; text-align: center; margin-top: 10px">
        <button
          class="btn btn-info btn-fill btn-wd"
          @click="closeModal"
          style="margin: auto"
        >
          Get Started
        </button>
      </div>
    </el-dialog>

    <div style="margin-bottom: 10px; margin-top: 10px">
      <div
        v-if="
          currentWorkspace &&
          currentWorkspace.workspace_type == 'General Partner'
        "
        style="/*padding-left: 15px*/"
      >
        <div class="d-flex" style="padding-bottom: 20px; padding-left: 15px">
          <div class="fundPerformanceCls">Fund Performance</div>

          <div
            style="margin-left: 10px; cursor: pointer"
            @click="downloadDashboardTables"
          >
            <img
              v-b-tooltip
              title="Download Fund Performance"
              src="static/img/gpDashboardDownload.svg"
            />
          </div>
        </div>
        <div class="row ml-0 mr-0 w-100">
          <div class="col-md-6" style="padding-left: 12px; padding-right: 10px">
            <div class="card gpCardPadding">
              <div style="text-align: center; padding-bottom: 30px">
                <div class="gp-bold-dashboard pb-1">Portfolio Value</div>

                <div class="gp-bold-dashboard-value">
                  ${{ precisionNumberForamtter(portfolioValue, 1) }}
                </div>
              </div>
              <div class="row pl-0 pr-0" style="padding-bottom: 20px">
                <div class="col-md-4">
                  <div class="gp-medium-dashboard pb-1">Fund Size</div>
                  <div class="gp-medium-dashboard-value">
                    {{
                      summaryData.length > 0 &&
                      summaryData[0].capital_commitment
                        ? `$${this.precisionNumberForamtter(
                            summaryData[0].capital_commitment,
                            1
                          )}`
                        : 0
                    }}
                  </div>
                </div>
                <div class="col-md-4" style="text-align: center">
                  <div class="gp-medium-dashboard pb-1">Capital Called</div>
                  <div class="gp-medium-dashboard-value">
                    {{
                      summaryData.length > 0 &&
                      summaryData[0].capital_called_to_date_amount
                        ? `$${this.precisionNumberForamtter(
                            summaryData[0].capital_called_to_date_amount,
                            1
                          )}`
                        : 0
                    }}
                  </div>
                  <div
                    class="gp-subHeader-value"
                    v-if="
                      summaryData &&
                      summaryData.length > 0 &&
                      summaryData[0].last_call
                    "
                  >
                    Last call :{{
                      moment(summaryData[0].last_call).format("MM/DD/YYYY")
                    }}
                  </div>
                </div>
                <div
                  class="col-md-4 p-0"
                  id="distributionId"
                  style="cursor: pointer"
                >
                  <div class="gp-medium-dashboard pb-1">Distributions</div>
                  <div class="gp-medium-dashboard-value">
                    {{ distributedToDateValue }}
                  </div>
                </div>
                <b-popover
                  target="distributionId"
                  triggers="hover"
                  placement="topright"
                  custom-class
                >
                  <div class="d-flex">
                    <div>
                      <div
                        class="gp-medium-dashboard-value"
                        style="font-size: 20px"
                      >
                        {{ lpDistributions }}
                      </div>
                      <div class="gp-subHeader-value">LP</div>
                    </div>
                    <div style="margin-left: 20px">
                      <div
                        class="gp-medium-dashboard-value"
                        style="font-size: 20px"
                      >
                        {{ gpDistributions }}
                      </div>
                      <div class="gp-subHeader-value">GP</div>
                    </div>
                  </div>
                </b-popover>
              </div>
              <div class="row pl-0 pr-0">
                <div class="col-md-4">
                  <div class="gp-medium-dashboard">TVPI: {{ tvpiValue }}</div>
                </div>
                <div class="col-md-4">
                  <div class="gp-medium-dashboard">MOIC: {{ moicValue }}</div>
                </div>
                <div class="col-md-4">
                  <div class="gp-medium-dashboard">IRR: {{ irrValue }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6" style="padding-left: 10px">
            <div class="card gpCardPadding">
              <div style="text-align: center; padding-bottom: 30px">
                <div class="gp-bold-dashboard pb-1">Deployed Capital</div>
                <div class="gp-bold-dashboard-value">
                  ${{ this.precisionNumberForamtter(portfolioCost, 1) }}
                </div>
              </div>
              <div class="row pl-0 pr-0">
                <div class="col-md-4">
                  <div class="gp-medium-dashboard pb-1">Investments</div>
                  <div class="gp-medium-dashboard-value">
                    {{ investmentsCount ? investmentsCount.length : 0 }}
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="gp-medium-dashboard pb-1">Follow-on's</div>
                  <div class="gp-medium-dashboard-value">
                    {{ followOnCount }}
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="gp-medium-dashboard pb-1">Exits</div>
                  <div class="gp-medium-dashboard-value">{{ exits }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="padding-left: 20px" v-else>
        <div class="col-md-3" style="padding-right: 0px">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div
                class="dashboard-portfolio"
                @click="navigatePortfolio"
                style="cursor: pointer"
              >
                Portfolio Value
              </div>
              <div
                class="d-flex"
                @click="navigatePortfolio"
                style="cursor: pointer"
              >
                <div class="dashboard-portfolio-value">
                  ${{ this.precisionNumberForamtter(portfolioValue, 1) }}
                </div>
              </div>
            </div>
            <span class="dashboard-portfolio-value-line"></span>
          </div>
        </div>
        <div class="col-md-2" style="padding-right: 0px">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="dashboard-cost">Cost</div>

              <div class="dashboard-cost-value">
                ${{ this.precisionNumberForamtter(portfolioCost, 1) }}
              </div>
            </div>
            <span class="dashboard-cost-line"></span>
          </div>
        </div>
        <div class="col-md-2" style="padding-right: 0px">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="dashboard-gain">Gain</div>

              <div class="dashboard-gain-value" v-if="portfolioGain > 0">
                ${{ this.precisionNumberForamtter(portfolioGain, 1) }}
              </div>
              <div class="dashboard-gain-value" v-if="portfolioGain < 0">
                -${{ this.formatNumber(portfolioGain) }}
              </div>
              <div class="dashboard-gain-value" v-if="portfolioGain == 0">
                $0
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-stack outer grid-stack-animate">
      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.portfolioPerformanceByYear.dataGsX"
        :data-gs-y="dataSet.portfolioPerformanceByYear.dataGsY"
        data-gs-width="6"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="portfolioPerformanceByYear"
      >
        <div class="grid-stack-item-content card">
          <div class="dashboardGraphs dashboardGraphsROI">
            <portfolioPerformanceByYear></portfolioPerformanceByYear>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.portfolioPerformanceTable.dataGsX"
        :data-gs-y="dataSet.portfolioPerformanceTable.dataGsY"
        data-gs-width="6"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="portfolioPerformanceTable"
      >
        <div class="grid-stack-item-content card">
          <portfolioPerformanceTable></portfolioPerformanceTable>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.bubbleGainLossId.dataGsX"
        :data-gs-y="dataSet.bubbleGainLossId.dataGsY"
        data-gs-width="6"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="bubbleGainLossId"
      >
        <div v-if="showPortfolioData" class="grid-stack-item-content card">
          <div class="dashboardBubbleChart" style="/*padding-right: 5px*/">
            <bubbleGainLossChartCard></bubbleGainLossChartCard>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.funnelPiePortfolioId.dataGsX"
        :data-gs-y="dataSet.funnelPiePortfolioId.dataGsY"
        data-gs-width="6"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="funnelPiePortfolioId"
      >
        <div v-if="showFunnelPiePortfolio" class="grid-stack-item-content card">
          <div class="dashboardGraphsPie">
            <funnelChartCard></funnelChartCard>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.proRataChartId.dataGsX"
        :data-gs-y="dataSet.proRataChartId.dataGsY"
        data-gs-width="4"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="proRataChartId"
      >
        <div v-if="showProRataChart" class="grid-stack-item-content card">
          <div
            class="dashboardGraphsPieDiligence dashboardGraphsPieProRataCanvas"
          >
            <pie-proRata-chart-card></pie-proRata-chart-card>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.pieDiligenceId.dataGsX"
        :data-gs-y="dataSet.pieDiligenceId.dataGsY"
        data-gs-width="4"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="pieDiligenceId"
      >
        <div v-if="showPieDiligence" class="grid-stack-item-content card">
          <div
            class="dashboardGraphsPieDiligence dashboardGraphsPieDiligenceCanvas"
            style="/*padding-right: 5px*/"
          >
            <pie-diligence-chart-card></pie-diligence-chart-card>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.referrerChartId.dataGsX"
        :data-gs-y="dataSet.referrerChartId.dataGsY"
        data-gs-width="4"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="referrerChartId"
      >
        <div v-if="showReferrerChart" class="grid-stack-item-content card">
          <div
            class="dashboardGraphsPieDiligence dashboardGraphsPieDiligenceCanvas"
          >
            <pie-referrer-chart-card></pie-referrer-chart-card>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.roiChartsCard.dataGsX"
        :data-gs-y="dataSet.roiChartsCard.dataGsY"
        data-gs-width="12"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="roiChartsCard"
      >
        <div class="grid-stack-item-content card">
          <div class="row mr-0 ml-0 w-100">
            <div class="col-md-6">
              <div class="dashboardGraphs dashboardGraphsROI">
                <bar-roi-chart-card></bar-roi-chart-card>
              </div>
            </div>
            <div class="col-md-6 pl-0">
              <div class="dashboardGraphs dashboardGraphsROI">
                <line-roi-time-chart-card></line-roi-time-chart-card>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.newFeedCardId.dataGsX"
        :data-gs-y="dataSet.newFeedCardId.dataGsY"
        data-gs-width="6"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="newFeedCardId"
      >
        <div class="grid-stack-item-content card">
          <div class="dashboardGraphs">
            <newsFeedCard
              :newsFeedList="newsFeed"
              context="Dashboard"
            ></newsFeedCard>
          </div>
        </div>
      </div>

      <div
        class="grid-stack-item"
        :data-gs-x="dataSet.portfolioValueId.dataGsX"
        :data-gs-y="dataSet.portfolioValueId.dataGsY"
        data-gs-width="4"
        data-gs-height="3"
        data-gs-no-resize="true"
        id="portfolioValueId"
      >
        <div class="grid-stack-item-content card">
          <div class="dashboardGraphsPie">
            <pie-portfolio-chart-card
              defaultSelected="sector"
              defaultMainCategorySelected="Portfolio Value"
              v-if="portfolioValue && portfolioValue > 0"
            ></pie-portfolio-chart-card>
            <div v-else style="margin-top: 150px">
              <div class="d-flex justify-content-center">
                <div style="font-size: 12px; line-height: 24px">
                  Portfolio value
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <div style="font-size: 18px; line-height: 14px">0</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DashboardExport
      :tableOne="downloadFundPerformance"
      :tableTwo="downloadTopCompanies"
      :fileName="fileName"
      v-if="showDownloadTables"
    ></DashboardExport>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import util from "util";
import api from "../../../axios_api";
import { Dialog, Select, Option } from "element-ui";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import {
  TabulatorCard,
  BarROIChartCard,
  LineROITimeChartCard,
  PiePortfolioChartCard,
} from "src/components/index";
import { mapGetters } from "vuex";
import {
  formatCurrency,
  vals,
  formatNumber,
  formatNumberWithComma,
  arrayGroupBy,
  precisionNumberForamtter,
} from "./../../../util";
import ReferresCard from "../../../components/Cards/ReferresCard";
import NewsFeedCard from "../../../components/Cards/NewsFeedCard";
import PieDiligenceChartCard from "../../../components/Cards/DefinedCharts/DiligencePieChartCard";
import PieProRataChardCard from "../../../components/Cards/DefinedCharts/ProRataPieChartCard";
import PieReferrerChartCard from "../../../components/Cards/DefinedCharts/ReferrerPieChartCard";
import PortfolioPerformanceByYear from "../../../components/Cards/DefinedCharts/PortfolioPerformanceLineChart";
import PortfolioPerformance from "../../../components/Cards/PortfolioPerformance";
import FunnelChartCard from "../../../components/Cards/DefinedCharts/FunnelChartCard";
import BubbleGainLossChartCard from "../../../components/Cards/DefinedCharts/BubbleGainLossChartCard";
import { GridStack } from "gridstack";
import DashboardExport from "../../Dashboard/Dashboard/DashboardExport";
const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
const DATA_STATUS_UPDATING = "Retrieving";
const DATA_STATUS_CONFIRMED = "Confirmed";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    TabulatorCard,
    DashboardExport,
    [BarROIChartCard.name]: BarROIChartCard,
    [LineROITimeChartCard.name]: LineROITimeChartCard,
    [PiePortfolioChartCard.name]: PiePortfolioChartCard,
    ReferresCard,
    [NewsFeedCard.name]: NewsFeedCard,
    [PieDiligenceChartCard.name]: PieDiligenceChartCard,
    [PieProRataChardCard.name]: PieProRataChardCard,
    [PieReferrerChartCard.name]: PieReferrerChartCard,
    [PortfolioPerformanceByYear.name]: PortfolioPerformanceByYear,
    [PortfolioPerformance.name]: PortfolioPerformance,
    [FunnelChartCard.name]: FunnelChartCard,
    [BubbleGainLossChartCard.name]: BubbleGainLossChartCard,
  },
  computed: {
    moment() {
      return moment;
    },
    ...mapGetters("portfolio", ["portfolioData", "portfolioAll"]),
    ...mapGetters("user", ["currency"]),
    ...mapGetters("dashboardCoordinates", ["coordinates"]),
    ...mapGetters("newsFeed", ["newsFeed"]),
    ...mapGetters("charts", [
      "portfolioValueByProperty",
      "portfolioROIByProperty",
    ]),
    ...mapGetters("company", ["companyData"]),
    ...mapGetters("investment", ["showProRataChart"]),
    ...mapGetters("diligence", ["diligenceCount"]),
    ...mapGetters("referrer", ["getReffersLength"]),
    ...mapGetters("workspacePlans", ["feature", "plan"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    ...mapGetters("lpAllocations", [
      "summaryData",
      "detailsData",
      "thesisData",
      "fundDetailsData",
      "lpDetailsData",
    ]),
    ...mapGetters("investment", ["investments"]),
    followOnCount() {
      let portfolioObj = {},
        values = [],
        count = 0;
      if (this.investments && this.investments.length > 0) {
        this.investments.map((item) => {
          if (!item.transaction_type || item.transaction_type == "Investment") {
            if (!portfolioObj[item.portfolio_item]) {
              portfolioObj[item.portfolio_item] = { count: 0 };
            }
            portfolioObj[item.portfolio_item].count++;
          }
        });
        values = Object.values(portfolioObj);
        values.map((item) => {
          if (item.count > 1) count++;
        });
      }
      return count;
    },
    investmentsCount() {
      let portfolioObj = {},
        count = 0;
      if (this.investments && this.investments.length > 0) {
        this.investments.map((item) => {
          if (!item.transaction_type || item.transaction_type == "Investment") {
            if (!portfolioObj[item.portfolio_item]) {
              portfolioObj[item.portfolio_item] = { count: 0 };
            }
            portfolioObj[item.portfolio_item].count++;
          }
        });
        count = Object.keys(portfolioObj);
      }
      return count;
    },
    moicValue() {
      return this.portfolioCost && this.portfolioCost > 0
        ? Number(
            (Number(this.portfolioValue) / Number(this.portfolioCost)).toFixed(
              2
            )
          )
        : 0;
    },
    tvpiValue() {
      let totalLpCapitalCalled = 0;
      let lpDetailsData = JSON.parse(JSON.stringify(this.lpDetailsData));
      if (lpDetailsData && lpDetailsData.length > 0) {
        lpDetailsData.map((item) => {
          if (
            item &&
            item.hasOwnProperty("capital_called") &&
            Number(item.capital_called) > 0
          ) {
            totalLpCapitalCalled += Number(item.capital_called);
          }
        });
      }
      return Number(totalLpCapitalCalled) > 0
        ? Number(
            (
              Number(this.portfolioValue) / Number(totalLpCapitalCalled)
            ).toFixed(2)
          )
        : 0;
    },
    exits() {
      let exits = ["Acquired", "Out of Business", "Exit", "IPO"],
        count = 0;
      if (this.portfolioData && this.portfolioData.length > 0) {
        this.portfolioData.map((item) => {
          if (item.status && exits.includes(item.status)) count++;
        });
      }
      return count;
    },
    lpDistributions() {
      let value = 0;
      if (this.detailsData && this.detailsData.length > 0) {
        this.detailsData.map((item) => {
          if (item.entity_type == "LP") value += item.distributions;
        });
      }
      return `$${this.precisionNumberForamtter(value, 1)}`;
    },
    gpDistributions() {
      let value = 0;
      if (this.detailsData && this.detailsData.length > 0) {
        this.detailsData.map((item) => {
          if (item.entity_type != "LP") value += item.distributions;
        });
      }
      return `$${this.precisionNumberForamtter(value, 1)}`;
    },
    distributedToDateValue() {
      let data = this.summaryData;
      let retval =
        data &&
        data.length > 0 &&
        data[0].hasOwnProperty("distributed_to_date") &&
        Number(data[0].distributed_to_date) > 0
          ? `$${precisionNumberForamtter(
              Number(data[0].distributed_to_date),
              1
            )}`
          : `$0`;
      return retval;
    },
    activeCompanies() {
      let values = _.filter(this.portfolioData, (pd) => {
        if (
          pd.data_status.toLowerCase() != "unconfirmed" &&
          pd.data_status.toLowerCase() != "nocompanyurl"
        ) {
          if (pd.status && pd.status.toLowerCase() != "out of business") {
            return pd;
          } else {
            if (!pd.status) {
              return pd;
            }
          }
        }
      });
      values = _.map(values, (data) => {
        data["multiple"] = this.computeMultiple(data);
        data["gain_loss"] = this.computeGainLoss(data);
        data["status"] = data["status"] ? data["status"] : "Unknown";
        // data["last_funding_round"] = data["last_funding_round"]
        //   ? moment(data["last_funding_round"]).format("MM/DD/YYYY")
        //   : "missing date";
        return data;
      });
      values = _.sortBy(values, [
        function (pd) {
          return -pd.gain_loss;
        },
      ]);
      let data = values.slice(0, 10);
      return {
        data: values.slice(0, 5),
        options: {
          layout: "fitColumns",
          tooltips: true,
          layoutColumnsOnNewData: true,
          virtualDom: false,
          tooltipsHeader: true,
          initialSort: [{ column: "gain_loss", dir: "desc" }],
          placeholder: "No records to view",
        },
        columns: this.tableColumns,
      };
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
    portfolioCost() {
      // sum up our porfolio cost
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.cost)) sum += item.cost;
        });
      }
      return sum;
    },
    portfolioGain() {
      this.costLength = ("" + this.portfolioCost).length;
      this.valueLength = ("" + this.portfolioValue).length;
      return this.portfolioValue - this.portfolioCost;
    },
    portfolioCount() {
      // update our display
      return this.portfolioData.length;
    },
    exitCashInvested() {
      // total cost of all companies marked 'exit'
      return _.reduce(
        this.portfolioData,
        (cost, gram) => {
          if (
            _.isNil(gram) ||
            _.isNil(gram.status) ||
            !(
              gram.status.toLowerCase() == "exit" ||
              gram.status.toLowerCase() == "acquired"
            )
          )
            return cost;
          return cost + gram.cost;
        },
        0
      );
    },
    exitCashReturned() {
      // total difference of value and cost for all companies marked exit
      return _.reduce(
        this.portfolioData,
        (gain, gram) => {
          if (
            _.isNil(gram) ||
            _.isNil(gram.status) ||
            !(
              gram.status.toLowerCase() == "exit" ||
              gram.status.toLowerCase() == "acquired"
            )
          )
            return gain;
          return gain + gram.value - gram.cost;
        },
        0
      );
    },
    exitMultiple() {
      // ratio of invested/returned
      let m = this.exitCashInvested / this.exitCashReturned;
      return _.isNaN(m) ? (0).toFixed(2) : m.toFixed(2);
    },
    overviewTooltip() {
      // text for the overview data (total)
      return vals.TOOLTIP_OVERVIEW.default;
    },
    tableColumns() {
      const self = this;
      return [
        {
          title: "Company",
          field: "name",
          sorter: "string",
          cssClass: "link",
          formatter: function (cell) {
            return cell.getValue();
          },
          cellClick: function (e, cell) {
            // set the 'current company' and go to the company profile
            let name = cell.getValue();
            // get the ucid
            let ucid = _.reduce(
              self.portfolioData,
              (memo, data) => {
                if (data.name == name) return data.ucid;
                return memo;
              },
              -1
            );
            // save our current company and go to the profile page
            self.$store.commit("temp/currentCompany", ucid);
            self.$router.push(
              `/${self.$route.params.account_id}/${self.$route.params.workspace_id}/companyProfile/${ucid}`
            );
          },
        },
        {
          title: "Status",
          field: "status",
          sorter: "string",
          width: 100,
          resizable: true,
        },
        {
          title: "Cost ($)",
          field: "cost",
          sorter: "number",
          formatter: "money",
          formatterParams: this.currency.format,
        },
        {
          title: "Gain/Loss ($)",
          field: "gain_loss",
          sorter: "number",
          //formatter: "money",
          //formatterParams: this.currency.format
          formatter: function (cell, params) {
            let data = cell.getData();
            let gain_loss =
              data.value >= 0 && data.cost >= 0 ? data.value - data.cost : 0;
            return gain_loss < 0 ? `-$${Math.abs(gain_loss)}` : `$${gain_loss}`;
          },
        },
        {
          title: "Last Funding Round",
          field: "last_funding_round",
          sorter: function (a, b, aRow, bRow, column, dir, sorterParams) {
            let data;
            if (a != "-" && b != "-")
              data = new Date(a).getTime() - new Date(b).getTime();
            else if (a != "-") data = new Date(a).getTime();
            else data = -new Date(b).getTime();
            return data;
          },
          width: 200,
          formatter: function (cell, formatterParams) {
            let data = cell.getData();
            if (
              data.last_funding_round &&
              data.last_funding_round != "-" &&
              data.last_funding_round != "missing date"
            ) {
              return moment(data.last_funding_round).format("MM/DD/YYYY");
            } else {
              return "-";
            }
          },
        },
        { title: "Current Stage", field: "stage", sorter: "string" },
        { title: "Sector", field: "sector", sorter: "string" },
      ];
    },
    showDiligenceGraph() {
      let featureIndex = this.feature.findIndex((item) => {
        if (item == "DEAL_FLOW_TRACKING") return item;
      });
      if (featureIndex >= 0) return true;
      else return false;
    },
    fileName() {
      let workspace_title = this.currentWorkspace.workspace_title
        ? this.currentWorkspace.workspace_title
        : "";
      let fileName = "";
      if (workspace_title && workspace_title.length > 0) {
        fileName = `${workspace_title}_Export-${moment(new Date()).format(
          "MM/DD/YYYY"
        )}.xlsx`;
      } else {
        fileName = `Dashboard_Export-${moment(new Date()).format(
          "MM/DD/YYYY"
        )}.xlsx`;
      }
      return fileName;
    },
    downloadTopCompanies() {
      let self = this;
      let values = _.filter(this.portfolioData, (pd) => {
        if (
          pd.data_status.toLowerCase() != "unconfirmed" &&
          pd.data_status.toLowerCase() != "nocompanyurl"
        ) {
          if (pd.status && pd.status.toLowerCase() != "out of business") {
            return pd;
          } else {
            if (!pd.status) {
              return pd;
            }
          }
        }
      });
      values = _.map(values, (data) => {
        data["gain_loss"] = this.computeGainLoss(data);
        return data;
      });
      values = _.sortBy(values, [
        function (pd) {
          return -pd.gain_loss;
        },
      ]);
      let data = values.slice(0, 10);
      data = data.length >= 5 ? data.slice(0, 5) : data;
      data.map((item) => {
        item.tractionItem = self.$store.getters["charts/companyTractionData"](
          item._id
        );
        if (item.tractionItem && item.tractionItem.length > 0) {
          item.tractionArr = item.tractionItem[0].arr
            ? `$${self.formatNumberWithComma(item.tractionItem[0].arr)}`
            : `$0`;
        }
        item.valuationItem = self.$store.getters[
          "rounds/roundsByPortfolioIdSorted"
        ](item._id);
        if (item.valuationItem && item.valuationItem.length > 0) {
          let valuationItem = item.valuationItem[0];
          item.valuationRoundSize = valuationItem.roundSize
            ? `$${self.formatNumberWithComma(valuationItem.roundSize)}`
            : `$0`;
          item.valuationPost = valuationItem.postMoney
            ? `$${self.formatNumberWithComma(valuationItem.postMoney)}`
            : `$0`;
          item.valuationDate = valuationItem.date
            ? moment(valuationItem.date).format("MM/DD/YYYY")
            : "-";
        }
      });

      let returnData = [];
      data.map((item) =>
        returnData.push([
          item.name,
          item.tractionArr,
          item.valuationPost,
          item.valuationRoundSize,
          item.valuationDate,
        ])
      );
      return returnData;
    },
    downloadFundPerformance() {
      this.$toaster.success("Download In-progress...");
      return [
        [
          "Vintage",
          this.thesisData.length > 0 && this.thesisData[0].vintage
            ? this.thesisData[0].vintage
            : "-",
        ],
        ["Number of portfolio companies", this.portfolioData.length],
        [
          "Fund size",
          this.summaryData.length > 0 && this.summaryData[0].capital_commitment
            ? `$${this.formatNumberWithComma(
                this.summaryData[0].capital_commitment
              )}`
            : "-",
        ],
        [
          "Fund status",
          this.thesisData.length > 0 && this.thesisData[0].status
            ? this.thesisData[0].status
            : "-",
        ],
        ["Number of exits", this.exits || "-"],
        ["Paid in capital", this.paidInCapital()],
        [
          "Capital deployed",
          `$${this.formatNumberWithComma(this.portfolioCost)}`,
        ],
        ["Initial investment", this.exportInitialInvestment()],
        ["Amount of follow-on", this.exportAmountFollowOn()],
        [
          "Capital distributed",

          this.fundDetailsData.length > 0 &&
          this.fundDetailsData[0].distributions
            ? `$${this.formatNumberWithComma(
                this.fundDetailsData[0].distributions
              )}`
            : "-",
        ],
        [
          "Value of portfolio",
          this.portfolioValue
            ? `$${this.formatNumberWithComma(this.portfolioValue)}`
            : "-",
        ],
        ["Multiple on Invested Capital (MOIC)", this.moicValue],
        ["Net Total Value to Paid In (TVPI)", this.tvpiValue],
        [
          "Net Distributions to Paid In (DPI)",
          this.summaryData.length > 0 && this.summaryData[0].net_dpi
            ? this.summaryData[0].net_dpi
            : "-",
        ],
      ];
    },
  },
  data() {
    return {
      dataSet: {},
      modals: {
        custom: false,
        dataimport: false,
      },
      draggedChanges: false,
      vals,
      newsFeedList: [],
      roi: { selected: "sector", title: "Sector" },
      valueA: { selected: "sector", title: "Sector" },
      valueB: { selected: "stage", title: "Stage" },
      updateDisplay: 0,
      showNewModal: false,
      newsModal: false,
      perPage: 10,
      costLength: 0,
      valueLength: 0,
      fundTitle: "",
      showDownloadTables: false,

      showReferrerChart: true,
      showPortfolioData: true,
      showFunnelPiePortfolio: true,
      showPieDiligence: true,
      grid: null,
      irrValue: 0,
      totalIRRProfit: 0,
      totalIRRCost: 0,
    };
  },
  toolTip: {
    type: String,
    default() {
      return "Portfolio Value: Summation of all values of all companies in your portfolio on paper; Portfolio Cost: Summation of all costs of all companies in your portfolio on paper; Portfolio Gain: The total value of your portfolio on paper; Total Cash Invested: Summation of the costs of all companies that are either ‘exit’ or ‘acquired’ in your portfolio; Total Cash Returned: Summation of the values of all companies that are either ‘exit’ or ‘acquired’ in your portfolio; Combined exit multiple: The ratio of cash invested and cash returned that are either ‘exit’ or ‘acquired’ in your portfolio";
    },
  },
  methods: {
    formatCurrency: formatCurrency,
    arrayGroupBy: arrayGroupBy,
    precisionNumberForamtter: precisionNumberForamtter,
    async downloadDashboardTables() {
      let self = this;
      const title =
        this.thesisData.length > 0 && this.thesisData[0].name
          ? `${this.thesisData[0].name} as of ${moment(new Date()).format(
              "MM/DD/YYYY"
            )}`
          : "-";
      const header = ["Name", "Value"];
      const tabulatorHeader = [
        "Company",
        "ARR",
        "Post Money Valuation",
        "Round Size",
        "As of",
      ];
      const data = this.downloadFundPerformance;
      let workbook = new Workbook();
      //1st Sheet setup
      let worksheet = workbook.addWorksheet("Fund Performance");
      let titleRow = worksheet.addRow([title]);
      titleRow.font = {
        name: "Arial",
        family: 4,
        size: 10,
        bold: true,
      };
      worksheet.mergeCells("A1:B1");
      //Add Header Row
      let headerRow = worksheet.addRow(header);

      // Cell Style : Fill and Border
      headerRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFF00" },
          bgColor: { argb: "FF0000FF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      data.forEach((d) => {
        let row = worksheet.addRow(d);
      });
      worksheet.getColumn(1).width = 30;
      worksheet.getColumn(2).width = 10;

      //Second Sheet
      let newworksheet = workbook.addWorksheet("Top 5 Performing Companies");
      let secondHeaderRow = newworksheet.addRow(tabulatorHeader);
      let secondData = this.downloadTopCompanies;

      // Cell Style : Fill and Border
      secondHeaderRow.eachCell((cell, number) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFF00" },
          bgColor: { argb: "FF0000FF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      secondData.forEach((d) => {
        let row = newworksheet.addRow(d);
      });
      newworksheet.getColumn(1).width = 25;
      newworksheet.getColumn(2).width = 10;
      newworksheet.getColumn(3).width = 25;
      newworksheet.getColumn(4).width = 15;
      newworksheet.getColumn(5).width = 15;

      //Generate File

      workbook.xlsx.writeBuffer().then((data) => {
        let blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fs.saveAs(blob, this.fileName);
      });
    },
    paidInCapital() {
      let lpDetailsData = JSON.parse(JSON.stringify(this.lpDetailsData));
      let totalLpCapitalCalled = 0;
      if (lpDetailsData && lpDetailsData.length > 0) {
        lpDetailsData.map((item) => {
          if (
            item &&
            item.hasOwnProperty("capital_called") &&
            Number(item.capital_called) > 0
          ) {
            totalLpCapitalCalled += Number(item.capital_called);
          }
        });
      }
      return `$${this.formatNumberWithComma(totalLpCapitalCalled)}`;
    },
    TimeSpanOfVintage(data) {
      if (data.startDate && data.endDate)
        return `${moment(data.startDate).format("MM/DD/YYYY")} - ${moment(
          data.endDate
        ).format("MM/DD/YYYY")}`;
      else if (data.startDate)
        return `${moment(data.startDate).format("MM/DD/YYYY")}`;
      return "-";
    },
    formatNumberWithComma: formatNumberWithComma,
    exportInitialInvestment() {
      let arr = [],
        sum = 0;
      let investmentsByportfolioItem = this.arrayGroupBy(
        this.investments,
        "portfolio_item"
      );
      for (let key in investmentsByportfolioItem) {
        if (investmentsByportfolioItem[key].length == 1)
          arr.push(investmentsByportfolioItem[key][0]);
        else {
          let items = _.sortBy(investmentsByportfolioItem[key], "created");
          arr.push(items[0]);
        }
      }
      if (arr.length > 0) {
        arr.map((item) => {
          if (item.amount && parseInt(item.amount))
            sum += parseInt(item.amount);
        });
      }
      return `$${this.formatNumberWithComma(sum)}`;
    },
    exportAmountFollowOn() {
      let arr = [],
        sum = 0;
      let investmentsByportfolioItem = this.arrayGroupBy(
        this.investments,
        "portfolio_item"
      );
      for (let key in investmentsByportfolioItem) {
        if (investmentsByportfolioItem[key].length > 1) {
          let items = _.sortBy(investmentsByportfolioItem[key], "created");
          let data = items.slice(1, items.length);
          arr.push(...data);
        }
      }
      if (arr.length > 0) {
        arr.map((item) => {
          if (item.amount && parseInt(item.amount))
            sum += parseInt(item.amount);
        });
      }
      return `$${this.formatNumberWithComma(sum)}`;
    },
    computeGainLoss(data) {
      return data.value >= 0 && data.cost >= 0 ? data.value - data.cost : 0;
    },
    computeMultiple(data) {
      return (data.value / data.cost).toFixed(2);
    },
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal() {
      // save that we have seen the modal
      this.showNewModal = false;
      this.$store.commit("user/markNew", { newProfile: false });
      // redirect to the portfolio page and show modal
      this.$router.push(
        `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio`
      );
      //this.$router.push("/portfolio");
    },
    navigatePortfolio() {
      this.$router.push(
        `/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio`
      );
    },
    formatNumber: formatNumber,
    saveCoordinates() {
      let self = this,
        workspace_id = "";
      self.draggedChanges = false;
      if (self.$route && self.$route.params && self.$route.params.workspace_id)
        workspace_id = self.$route.params.workspace_id;
      else {
        let currentWorkspace =
          self.$store.getters["workspace/currentWorkspace"];
        workspace_id = currentWorkspace.workspace_id;
      }
      self.$store
        .dispatch("dashboardCoordinates/apiPostCoordinates", {
          coordinates: self.dataSet,
          workspace_id,
        })
        .then((data) => {})
        .catch((err) => {
          console.log({ err });
        });
    },

    setGrid() {
      let height = window.screen.height;

      if (height < 768) {
        self.grid = GridStack.init({
          marginBottom: "22px",
        });
      } else {
        self.grid = GridStack.init();
      }

      self.grid.on("dragstop", function (event, el) {
        var divs = document.querySelectorAll(".grid-stack-item");
        let coordinates = {};
        self.draggedChanges = true;
        divs.forEach((item, index) => {
          if (!coordinates[item.id]) {
            coordinates[item.id] = { dataGsX: 0, dataGsY: 0 };
          }
          coordinates[item.id].dataGsX =
            item.dataset && item.dataset.gsX ? item.dataset.gsX : 0;
          coordinates[item.id].dataGsY =
            item.dataset && item.dataset.gsY ? item.dataset.gsY : 0;
        });
        self.dataSet = coordinates;
      });
    },
    setCardDisplay() {
      let self = this;

      if (!self.grid) {
        return;
      }

      if (self.getReffersLength > 0) {
        self.showReferrerChart = true;
      } else {
        self.showReferrerChart = false;
      }

      if (self.portfolioData.length > 0) {
        self.showPortfolioData = true;
      } else {
        self.showPortfolioData = true;
      }

      if (
        self.portfolioAll &&
        self.portfolioAll.length > 0 &&
        self.showDiligenceGraph
      ) {
        self.showFunnelPiePortfolio = true;
      } else {
        self.showFunnelPiePortfolio = false;
      }

      if (self.showDiligenceGraph && self.diligenceCount > 0) {
        self.showPieDiligence = true;
      } else {
        self.showPieDiligence = false;
      }
    },

    calculateIRR() {
      let self = this;
      let dates = [];
      let values = [];

      let investmentDates = [];

      self.portfolioAll.map((portfolioItem, index) => {
        let investmentData = self.$store.getters[
          "investment/investmentsByPortfolioId"
        ](portfolioItem._id, portfolioItem.workspace);
        let investment = JSON.parse(JSON.stringify(investmentData));

        investment.map((item) => {
          item.portfolio_item = portfolioItem._id;
          item.investment_type = item.investment_type
            ? item.investment_type
            : "Unknown";

          if (!item.transaction_type) item.transaction_type = "Investment";

          if (item.date) item.date = moment(item.date).format("MM/DD/YYYY");
          else if (item.transaction_date)
            item.date = moment(item.transaction_date).format("MM/DD/YYYY");
          else item.date = "-";

          if (item.investment_type === "Unknown") {
            item.investment_type = "-";
          }

          if (item.investment_type == "Proceeds") {
            self.totalIRRProfit += parseFloat(
              item.amount || item.proceeds_amount || 0
            );
            values.push(parseFloat(item.amount || item.proceeds_amount || 0));
          } else {
            self.totalIRRCost += parseFloat(item.amount);
            values.push(item.amount * -1);
          }

          dates.push(moment(item.date, "MM/DD/YYYY"));

          if (portfolioItem.status === "Active") {
            investmentDates.push(moment(item.date, "MM/DD/YYYY"));
          }
        });
      });

      window.moment = moment;

      if (investmentDates.length) {
        let sortedInvestmentDates = investmentDates.sort(function (
          left,
          right
        ) {
          return moment
            .utc(moment.utc(right.format("YYYY-MM-DD")))
            .diff(left.format("YYYY-MM-DD"));
        });

        // console.log("sortedInvestmentDates: ", sortedInvestmentDates.map((item)=>item.format('YYYY-MM-DD')))

        self.lastInvestmentDate = sortedInvestmentDates[0];
        values.push(parseFloat(self.portfolioValue - self.totalIRRProfit));
        dates.push(self.lastInvestmentDate);
      }

      let val = XIRR(values, dates) * 100;

      if (!isNaN(val)) {
        self.irrValue = parseFloat(val).toFixed(2);
      } else {
        self.irrValue = "-";
      }
    },
  },
  beforeMount() {
    let self = this;
    if (self.coordinates && self.coordinates.coordinates) {
      let workspaceKeys = Object.keys(self.coordinates.coordinates);
      let allKeys = Object.keys(self.vals.coordinates);
      let yArray = [],
        coordinatesKey = JSON.parse(
          JSON.stringify(self.coordinates.coordinates)
        );
      for (var key in coordinatesKey) {
        yArray.push(Number(coordinatesKey[key].dataGsY));
      }
      let yMax = Number(yArray.sort()[yArray.length - 1]) + 3;
      allKeys.map((item) => {
        if (item) {
          let index = workspaceKeys.findIndex(
            (workspaceKeyItem) => workspaceKeyItem == item
          );
          if (index < 0) {
            let currentMissingObj = self.vals.coordinates[item];
            let checkXY = false;
            let xVal = currentMissingObj.dataGsX;
            let yVal = currentMissingObj.dataGsY;
            for (var coordinateItem in coordinatesKey) {
              if (
                coordinatesKey[coordinateItem].dataGsX == xVal &&
                coordinatesKey[coordinateItem].dataGsY == yVal
              ) {
                checkXY = true;
                break;
              }
            }
            let obj = {};
            if (!checkXY) {
              obj = currentMissingObj;
            } else {
              obj = {
                dataGsX: 0,
                dataGsY: yMax,
              };
              yMax = yMax + 3;
            }
            coordinatesKey[item] = obj;
          }
        }
      });
      self.dataSet = coordinatesKey;
    } else {
      self.dataSet = self.vals.coordinates;
    }
  },
  watch: {
    coordinates: function (data) {
      let self = this;
      if (self.draggedChanges) {
        self.saveCoordinates();
      }
      if (self.coordinates && self.coordinates.coordinates) {
        self.dataSet = self.coordinates.coordinates;
      } else {
        self.dataSet = self.vals.coordinates;
      }
    },
    getReffersLength: function () {
      this.setCardDisplay();
    },
    portfolioData: function () {
      this.setCardDisplay();
    },

    portfolioAll: function () {
      this.setCardDisplay();
      this.calculateIRR();
    },
    showDiligenceGraph: function () {
      this.setCardDisplay();
    },
  },
  async mounted() {
    window.moment = moment;
    let self = this;
    self.$store.dispatch("newsFeed/getNewsFeeds");
    self.$store.dispatch("investment/getProRataData");
    self.$store.dispatch("charts/getGenderChartData");
    this.$store.commit("charts/setInitialValues");
    this.$store.commit("todo/setCurrentComponent", "dashboard");
    const titleEl = document.querySelector("head title");
    titleEl.textContent = `Fiifi | Dashboard`;
    // check to see if we have no data
    setTimeout(() => {
      let checkNew = self.$store.getters["user/isNew"];
      let data = self.$store.getters["portfolio/portfolioAll"];
      if (checkNew && data.length <= 0) {
        this.showNewModal = true;
      }
    }, 1500);

    if (this.portfolioData && this.portfolioData.length) {
      let showWarn = false;
      for (let i = 0; i < this.portfolioData.length; i++) {
        if (this.portfolioData[i]["data_status"] == DATA_STATUS_UNCONFIRMED) {
          showWarn = true;
          break;
        }
      }
      if (showWarn) {
        this.$store.commit("infobox/infoBoxVisibility", {
          show: true,
          isWarn: true,
          title: "Please note! You have unverified companies.",
          displayText: `This can affect the accuracy of your data below. 
            Please verify all companies to improve reporting.&nbsp;
            <a href="/#/${this.$route.params.account_id}/${this.$route.params.workspace_id}/portfolio?f=Unconfirmed" class="link">Click here </a>&nbsp;to view unverifed companies.`,
        });
      }
    }

    setTimeout(() => {
      self.setGrid();
      this.calculateIRR();
    }, 0);
  },

  beforeDestroy() {
    let self = this;
    if (self.draggedChanges) {
      self.saveCoordinates();
    }
    this.$store.commit("infobox/infoBoxVisibility", {
      show: false,
      displayText: ``,
    });
  },
};
</script>
<style>
.boldHiddenTabulatorTitles {
  font-weight: 900;
}
/* .grid-stack-item[data-gs-height="3"] {
  height: 350px !important;
} */
@media screen and (max-height: 700px) {
  .grid-stack-item[data-gs-height="3"] {
    height: 350px !important;
  }
}

.grid-stack-item-content {
  overflow: hidden !important;
}

.grid-stack-item-content .card {
  box-shadow: none !important;
}
.downloadFundDiv {
  color: #5445f3;
  margin-left: 5px;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
  font-size: 12px;
}
.newModalCls
  .el-dialog
  .el-dialog__header
  .el-dialog__headerbtn
  .el-dialog__close {
  color: #ffffff;
}
.company-second .tabulator-tableHolder {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 56px;
  /* max-height: 180px; */
}
.active-company-card {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 8px #00000007;
  border-radius: 3px;
  border: 1px solid #efefef;
  opacity: 1;
  padding-bottom: 30px;
  margin-bottom: 1.5rem;
}
.overview-help {
  margin-top: -20px;
  display: flex;
  justify-content: flex-end;
}

.steps li {
  line-height: 2em;
}
.welcome-callout,
.import-callout {
  display: flex;
}

.welcome-callout div,
.import-callout div {
  width: 30%;
  background-color: #f7f7f8;
  border-radius: 5px;
  box-sizing: border-box;
  margin: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.welcome-callout p,
.import-callout p {
  margin-top: 10px;
  word-break: normal;
}

.welcome-callout div i,
.import-callout div i,
.import-callout div img {
  margin-top: 15px;
  width: auto;
  /* color: #0097a7; */
  color: #5445f3;
}

.import-callout div i,
.import-callout div img {
  margin-bottom: 20px;
}

.notactiv {
  color: #888888 !important;
  opacity: 0.6;
}

#portfolioBottomLine > div {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

#portfolioBottomLine h5,
#portfolioBottomLine p span {
  color: #8c8c8c;
}
#portfolioBottomLine h1 {
  margin-top: -12px;
}

.portValue {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media only screen and (max-width: 1650px) {
  .portValue h1 {
    font-size: 2.5em;
  }
}

@media only screen and (max-width: 1250px) {
  .portValue h1 {
    font-size: 2em;
  }
}

@media only screen and (max-width: 1060px) {
  .portValue h1 {
    font-size: 1.5em;
  }
}

@media only screen and (max-width: 767px) {
  .portValue h1 {
    font-size: 3em;
  }
}

@media only screen and (max-width: 455px) {
  .portValue h1 {
    font-size: 2.5em;
  }
}

@media only screen and (max-width: 390px) {
  .portValue h1 {
    font-size: 2em;
  }
}

@media only screen and (max-width: 310px) {
  .portValue h1 {
    font-size: 1.5em;
  }
}

.costGain {
  padding-top: 10px;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  display: flex;
  justify-content: space-around;
  margin-bottom: 10px;
}

@media only screen and (max-width: 1600px) {
  .costGain {
    display: block;
  }
  .costGain div {
    text-align: center;
  }
}

.investedReturned div {
  display: flex;
  justify-content: space-between;
}

@media only screen and (max-width: 1360px) {
  .investedReturned div {
    display: block;
  }

  .investedReturned div p {
    margin-bottom: 0px;
  }

  .investedReturned div div:last-child {
    margin-bottom: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .investedReturned div {
    display: flex;
    justify-content: space-between;
  }
}

@media only screen and (max-width: 370px) {
  .investedReturned div {
    display: block;
  }
}

.companyCount {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.companyCount h1 {
  font-weight: bold;
  margin-bottom: 0px;
}

.ct-series-a .ct-bar {
  /* Colour of your bars */
  stroke: #517f45;
  /* The width of your bars */
  stroke-width: 20px;
}

.ct-series-b .ct-bar {
  /* Colour of your bars */
  stroke: #66bd51;
  /* The width of your bars */
  stroke-width: 14px;
}

#portValueBySector .ct-series-a .ct-slice-pie {
  fill: #75cbd3;
}

#portValueBySector .ct-series-b .ct-slice-pie {
  fill: #60c1cf;
}

#portValueBySector .ct-series-c .ct-slice-pie {
  fill: #45b8cc;
}

#portValueBySector .ct-series-d .ct-slice-pie {
  fill: #20afc7;
}

#portValueBySector .ct-series-e .ct-slice-pie {
  fill: #2c9cae;
}

#portByStage .ct-series-a .ct-slice-pie {
  fill: #a99ecd;
}

#portByStage .ct-series-b .ct-slice-pie {
  fill: #9789c1;
}

#portByStage .ct-series-c .ct-slice-pie {
  fill: #8677b6;
}

#portByStage .ct-series-d .ct-slice-pie {
  fill: #7766ad;
}

#portByStage .ct-series-e .ct-slice-pie {
  fill: #685a93;
}

#portByStage .ct-series-e .ct-slice-pie {
  fill: #594f7d;
}

#roiBySectorCard {
  height: calc(100% - 30px);
}

#portfolioBottomLine {
  min-height: 550px;
}

#portValueBySector {
  min-height: 550px;
}

#portByStage {
  min-height: 550px;
}

#roiBySectorCard {
  min-height: 550px;
}

@media only screen and (min-width: 1400px) {
  .legend {
    display: flex;
    justify-content: space-evenly;
  }

  .legend div {
    display: inline-block;
    margin: 5px;
  }
}

@media only screen and (max-width: 1400px) {
  #theMainTableBox {
    overflow-x: scroll;
  }

  #theMainTableFixer {
    width: 600px !important;
  }
}

/*#theMainTableBox > #theMainTableFixer > .tabulator > .tabulator-tableHolder > .tabulator-table > .tabulator-row > .tabulator-cell:first-child {
  color:#0097a7;
  text-decoration: underline;
}*/

.portfolio-summary-card {
  height: calc(100% - 30px);
  max-width: 530px;
}

@media only screen and (max-width: 768px) {
  .portfolio-summary-card {
    max-width: none;
  }
}

.dashboardTableTabulator
  .tabulator
  .tabulator-header
  .tabulator-col
  .tabulator-col-content
  .tabulator-arrow {
  /* margin-top: 10px; */
}

/* .tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover{
  background-color: none !important;
} */

.dashboardGraphs .card {
  /* height: 435px; */
  /* height: 283px; */
  height: 315px;
  margin-bottom: 20px;
}

.dashboardGraphs .card .card-body canvas {
  /* height: 350px !important; */
  height: 210px !important;
}

.dashboardGraphsPie .card {
  /* height: 435px; */
  /* height: 283px; */
  height: 315px;
  overflow: hidden;
  margin-bottom: 20px;
}

.dashboardBubbleChart .card {
  height: 315px;
  overflow: hidden;
  margin-bottom: 20px;
}

.dashboardGraphsPie .card .card-body canvas {
  /* height: 190px !important; */
  /* as legend is positioned bottom , added this height else remove */
  height: 250px !important;
}

.dashboardBubbleChart .card .card-body canvas {
  height: 240px !important;
}

.dashboardTableTabulatorMainDiv .card {
  margin-bottom: 20px !important;
}

.dashboardTableTabulator .card-body {
  padding-top: 8px !important;
}

.dashboardGraphsPieDiligence .card {
  /* height: 283px; */
  height: 315px;
  margin-bottom: 20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 1px 20px #0000000f;
  border-radius: 8px;
  opacity: 1;
}

.dashboardGraphsPieDiligenceCanvas .card .card-body canvas {
  /* height: 170px !important; changed @drag&drop revert if gridstack removed*/
  height: 180px !important;
  margin-left: auto;
  margin-right: auto;
}

.dashboardGraphsPieDiligence .card-body {
  padding-top: 30px;
}

.dashboardGraphsPieProRataCanvas .card .card-body canvas {
  height: 210px !important;
  margin-left: auto;
  margin-right: auto;
}

/* remove when rigths chart position changed */
.dashboardGraphsPieProRataCanvas .card {
  height: 315px;
  overflow: hidden;
  /* margin-bottom: 20px; */
}

.dashboardGraphsBar .card {
  /* height: 283px; */
  height: 315px;
  margin-bottom: 20px;
}

.dashboardGraphsBar .card .card-body canvas {
  height: 210px !important;
}

.dashboardGraphsPie .pieChartCardBox {
  /* commented this as legends are moved from right to bottom, to revert back to left unncomment this and remove height of canvas */
  /* height: 220px; */
}

.dashboardGraphsROI .card .card-body {
  padding-top: 0px !important;
}

.dashboardGraphs .newsCard {
  height: 315px;
  max-height: 315px;
}

.dashboardGraphs .newsFeedCardBodyLayout {
  height: 210px;
  min-height: 210px;
  max-height: 210px;
}

.dashboardGraphsROI .card-body {
  padding-top: 0px !important;
}

.dashboardGraphsROI canvas {
  height: 250px !important;
}
</style>
